const TARGET_ORIGIN = '*'

enum PXEC_POST_MESSAGES_TYPE {
  PRODUCT_DETAIL = '1',
  ADD_TO_CART = '2',
  OPEN_PRODUCT_LIST = '3',
  SHARE_ROOM = '4',
}

export const pxecPostMessages = {
  visitProductDetail: (pid: string, roomId: string) => {
    console.log('pxec post messages visit product detail', pid, roomId)
    window.parent.postMessage(
      {
        type: PXEC_POST_MESSAGES_TYPE.PRODUCT_DETAIL,
        pid,
        roomId,
      },
      TARGET_ORIGIN,
    )
  },
  buyNow: (pid: string, roomId: string) => {
    console.log('pxec post messages buy now', pid, roomId)
    window.parent.postMessage(
      {
        type: PXEC_POST_MESSAGES_TYPE.ADD_TO_CART,
        pid,
        roomId,
      },
      TARGET_ORIGIN,
    )
  },
  openProductList: (roomId: string, pids: string[]) => {
    console.log('pxec post messages open product list', roomId, pids)
    window.parent.postMessage(
      {
        type: PXEC_POST_MESSAGES_TYPE.OPEN_PRODUCT_LIST,
        roomId,
        pid: pids.join(','),
      },
      TARGET_ORIGIN,
    )
  },
  shareRoom: (roomId: string) => {
    console.log('pxec post messages share room', roomId)
    window.parent.postMessage(
      {
        type: PXEC_POST_MESSAGES_TYPE.SHARE_ROOM,
        roomId,
      },
      TARGET_ORIGIN,
    )
  },
}
